import { Component, Input } from '@angular/core';

@Component({
  selector: 'create-table-header',
  templateUrl: 'create-table-header.component.html',
  styleUrls: ['./create-table-header.component.scss']
})
export class CreateTableHeaderComponent {
  @Input() isAuthorityHistory = false;
  @Input() columnNames = [];
}
